import ThemedStateIcon from './ThemedStateIcon';

export default ThemedStateIcon;
